import { DeviceQL } from './../../providers/devices/models';
import { DevicesProvider } from './../../providers/devices/devices';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { TasksProvider } from '../../providers/tasks/tasks';
import { TaskQL, TaskData } from '../../providers/tasks/models';
import { Subscription } from 'rxjs';
import { SocketProvider } from '../../providers/socket/socket';
import { getValue } from '../../providers/tasks/filters'
@IonicPage()
@Component({
  selector: 'page-task-test-security',
  templateUrl: 'task-test-security.html'
})
export class TaskTestSecurityPage {
  commandRunning: boolean = false;
  commandResults: any = {};
  client: any;
  shadow: any;
  deviceSocket: any;
  signalStrength: number;

  private password: string;

  deviceSnn: string;
  passwordFault: boolean = false;
  socketReady: boolean = false;
  socketStatusText: string = 'Connecting to device';

  passValidate: any;
  passErrorMessage: any;

  client$: Subscription;
  device$: Subscription;
  shadow$: Subscription;
  account$: Subscription;

  deviceView: any;
  accountView: any;
  shadowView: any;
  socketInprogress: boolean = false;

  inprogress: boolean = false;
  isrepair: string;
  isreplace: boolean;
  task: TaskQL;
  taskData: TaskData;
  testData: { passed: boolean } = { passed: true };
  extras: any;
  serial: string;
  device: DeviceQL;
  testPassed: boolean = false;

  deviceProfile: string = 'snn:device-profile:secdev:v1'

  deviceTests: {
    label: string;
    value: string;
    type: 'time' | 'boolean';
    result: boolean;
    state: 'NONE' | 'SUCCEEDED' | 'FAILED';
    resultValue: boolean | number;
  }[] = [
    {
      label: 'Wiring Error',
      value: 'faultWiringError',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Installation Error',
      value: 'faultInstallationError',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Software Password Error',
      value: 'faultSoftwarePasswordRequired',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Out Of Sync',
      value: 'faultOutOfSync',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Command Counter Out Of Sync',
      value: 'faultCommandCounterOutOfSync',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    }
  ];

  zoneCount: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    private alertCtrl: AlertController,
    private toastController: ToastController,
    private sniotService: SocketProvider
  ) {}

  ionViewDidLoad() {
    this.task = this.tasksProvider.getSelectedTask(); // this.navParams.get('task');
    this.taskData = this.tasksProvider.getTaskData(this.task.id);

    this.extras = this.navParams.get('extras');
    this.isrepair = this.extras.isrepair;

    this.isreplace = this.extras && this.extras.isreplace ? this.extras.isreplace : null;

    this.serial = this.isrepair
      ? this.devicesProvider.getSerial(this.taskData.verified)
      : this.devicesProvider.getSerial(this.taskData.code);

    this.getDevice(this.serial, device => {
      if(!device) {
        this.passwordFault = false;
      }else{

        const zoneCount = getValue(device, 'active.meta.secdev:deviceInfo.zoneCount');
        if(zoneCount) this.zoneCount = zoneCount;
        const profile = getValue(device, 'active.profile');
        if(profile) this.deviceProfile = profile;

        this.deviceSnn = device.active.snn;
        const faultSoftwarePasswordRequired = getValue(device, 'active.shadowReference.state.reported.faultSoftwarePasswordRequired');
        this.passwordFault = faultSoftwarePasswordRequired? faultSoftwarePasswordRequired: false;
      }
    });

    this.initSocket();
  }

  ionViewDidLeave() {
    if (this.client$) this.client$.unsubscribe();
    if (this.shadow$) this.shadow$.unsubscribe();
  }

  initSocket() {
    this.client$ = this.sniotService.getClient().subscribe(client => {
      this.client = client;

      if (this.client) {
        this.client.deviceShadow
          .getDevice({serial: this.serial})
          .then(result => {
            this.deviceSocket = result;
            if (!this.socketReady) this.checkSocketStatus();
          })
          .catch(e => {
            console.log('e',e);
          })

        this.shadow$ = this.sniotService
          .bindCollection(client.deviceShadow.getShadowCollection(), {
            profile: this.deviceProfile,
            serial: this.serial
          })
          .subscribe(view => {
            this.shadowView = view;
            this.shadow = view.data.toArray()[0];
            if (!this.socketReady) this.checkSocketStatus();
          });
      }
    });
  }

  checkSocketStatus() {
    if ((this.deviceSocket || this.zoneCount) && this.shadow) {
      this.socketReady = true;
      this.socketStatusText = 'Connected';

      const signalStrength = getValue(this.shadow, 'state.reported.signalRssi');
      if(signalStrength) this.signalStrength = signalStrength;

      this.zoneCount = getValue(this.deviceSocket, 'active.meta.secdev:deviceInfo.zoneCount');
      this.socketStatusText = 'Connected';
    }
  }

  isDirty() {
    const zoneCount = getValue(this.deviceSocket, 'active.meta.secdev:deviceInfo.zoneCount');
    return zoneCount ? zoneCount !== this.zoneCount : true;
  }

  hasZoneCount() {
    const zoneCount = getValue(this.deviceSocket, 'active.meta.secdev:deviceInfo.zoneCount');
    return zoneCount? zoneCount: false;
  }

  setZones() {
    const device = this.deviceSocket? this.deviceSocket: this.device;
    const deviceSnn = device? device.active.snn: this.deviceSnn;
    const deviceInfo = getValue(device, 'active.meta.secdev:deviceInfo');

    let val = deviceInfo? { ...deviceInfo } : {};
    val.zoneCount = this.zoneCount;
    let payload = {
      meta: 'secdev:deviceInfo',
      value: val,
      snn: deviceSnn
    };
    this.socketInprogress = true;
    this.client.deviceShadow
      .updateDeviceInstanceMetaData(payload)
      .then(result => {
        this.socketInprogress = false;
        const toast = this.toastController.create({
          message: 'Zones updated',
          showCloseButton: true,
          duration: 10000,
          position: 'bottom'
        });
        toast.present();
      })
      .catch(e => {
        console.log('e',e);
        this.socketInprogress = false;
        let alert = this.alertCtrl.create({
          title: 'Error',
          message: 'Failed to update',
          buttons: [
            {
              text: 'Ok',
              role: 'ok',
              handler: data => {
                // TODO
              }
            }
          ]
        });
        alert.present();
      });
  }

  getReported(value: string) {
    return value &&
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.state &&
      this.device.active.shadowReference.state.reported
      ? this.device.active.shadowReference.state.reported[value]
      : null;
  }

  getMeta(value: string) {
    return value &&
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.metadata &&
      this.device.active.shadowReference.metadata.reported
      ? this.device.active.shadowReference.metadata.reported[value]
      : null;
  }

  getDevice(serial, done) {
    this.inprogress = true;
    this.devicesProvider.getDeviceQL({ serial: serial }).subscribe(
      result => {
        this.inprogress = false;
        done(result);
      },
      error => console.log(error)
    );
  }

  initTest() {
    this.getDevice(this.serial, result => {
      this.parseResults(result);
    });
  }
  parseResults(device: DeviceQL) {
    this.device = device;
    this.testPassed = true;
    this.deviceSnn = this.device.active.snn;
    const stateReported =
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.state
        ? this.device.active.shadowReference.state.reported
        : null;

    const meta =
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.metadata
        ? this.device.active.shadowReference.metadata.reported
        : null;

    this.deviceTests.forEach(test => {
      // test.result = test.type === 'time' ? state[test.value] : meta[test.value] ? meta[test.value].modified_ts : 0;
      // test.state = test.type === 'time' ?
      if (test.type === 'time') {
        test.result = stateReported[test.value];
        test.state =
          !stateReported[test.value] || new Date().getTime() - new Date(Number(stateReported[test.value])).getTime() > 60000
            ? 'FAILED'
            : 'SUCCEEDED';
        test.resultValue = test.state === 'FAILED' ? false : true;
      } else {
        test.result = meta && meta[test.value] && meta[test.value].modified_ts;
        test.state = stateReported[test.value] ? 'FAILED' : 'SUCCEEDED';
        test.resultValue = stateReported[test.value];
      }

      if (test.state === 'FAILED') {
        this.testPassed = false;
      }
    });

    if (this.testPassed) {
      setTimeout(() => {
        this.testData.passed = true;
        this.updateTask();
      }, 2000);
    } else {
      // for testing
      // this.updateTask();
      this.afterError();
    }
  }

  afterError() {
    this.testData.passed = false;
    if (this.isrepair) {
      // TODO: alert asking to replace or not
      let alert = this.alertCtrl.create({
        title: 'Error',
        message: 'Test failed. Test can be retried or device needs to be replaced.',
        buttons: [
          {
            text: 'Retry',
            role: 'retry',
            handler: data => {
              // for debugging this.updateTask();
            }
          },
          {
            text: 'Replace',
            role: 'replace',
            handler: data => {
              // for debugging this.updateTask();
              this.tasksProvider.updateTaskData(this.task, 'testrepair', 'error').subscribe(data => {
                // done
                this.taskData = this.tasksProvider.getTaskData(this.task.id);
                this.navCtrl.pop();
              });
            }
          }
        ]
      });
      alert.present();
    }
  }

  getValidation(test): 'NONE' | 'FAILED' | 'SUCCEEDED' {
    let state: 'NONE' | 'FAILED' | 'SUCCEEDED' = 'NONE';
    if (
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.state &&
      this.device.active.shadowReference.metadata
    ) {
      const reported = this.device.active.shadowReference.state.reported[test.value];
      const meta = this.device.active.shadowReference.metadata.reported[test.value];
      if (test.type === 'time') {
        state = new Date().getTime() - new Date(reported.lastTestTimestamp).getTime() > 60000 ? 'FAILED' : 'SUCCEEDED';
      } else {
        state = reported ? 'SUCCEEDED' : 'FAILED';
      }
    }
    return state;
  }

  updateTask() {
    let data = ['data'];
    let type = !this.isrepair ? 'test' : 'testrepair';
    this.tasksProvider.updateTaskData(this.task, type, this.testData).subscribe(data => {
      this.taskData = this.tasksProvider.getTaskData(this.task.id);
      this.navCtrl.pop();
    });
  }

  submitPass() {
    this.passErrorMessage = '';
    let error = false;
    const softwarePass = this.password;
    if (softwarePass) {
      if (softwarePass.length !== 4) error = true;

      const charactersAllowed = '0123456789BCDEF ';

      [...softwarePass.split('')].forEach(char => {
        if (!charactersAllowed.includes(char)) error = true;
      });
    } else {
      error = true;
    }

    if (!error) {
      this.passwordFault = false;

      this.sniotService
        .updateCommandDevice({
          command: 'secdev:setSoftwarePassword',
          params: { password: softwarePass },
          snn: this.deviceSnn
        })
        .subscribe(client => {
          this.socketInprogress = true;
          this.getDevice(this.serial, device => {
            this.socketInprogress = false;
            const toast = this.toastController.create({
              message: 'Software Password Set',
              showCloseButton: true,
              duration: 10000,
              position: 'bottom'
            });
            toast.present();
          });
        });
    } else {
      this.passErrorMessage = 'Password must be 4 chracters \n and can only inclued: 0123456789BCDEF and space.';
      this.passValidate = { 'border-bottom': '2px solid red' };
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-test-security/task-test-security.ts